// Port of SuiteModel/AgentBrief.swift: the writer's Notes for Assistants — one document in Research & Notes, marked
// `agent-brief`, where the writer tells agents what they need to know about the project. Agents read it first (MCP
// describe_project); they never write it. Ids derive from the project's, so two devices making it before they sync make
// one document (`StoreEditor.ensureAgentBrief`).
import { stableUUID } from './hashing.ts';
import type { MetadataValue } from './contract.ts';

export const AgentBrief = {
  /** Fragment metadata marker: `agent-brief: true`. */
  field: 'agent-brief',
  marker: 'true',
  title: 'Notes for Assistants',
  /** What a new brief says, until the writer writes over it. */
  template: 'Tell assistants what they need to know about this project: its shape, who is in it, what never '
    + 'happens, how you want drafts to read.\n\nAn assistant that connects reads this before it works here. It never changes it.',
  synopsis: 'What assistants should know before they work in this project.',
  fragmentID: (projectID: string) => stableUUID(`${projectID}|agent-brief|fragment`),
  nodeID: (projectID: string) => stableUUID(`${projectID}|agent-brief|node`),
  /** `AgentBrief.isUntouched`: the text still reads as the template (whitespace aside), or is empty. */
  isUntouched: (text: string): boolean => text.trim() === AgentBrief.template || text.trim() === '',
} as const;

/** `FragmentDocument.isAgentBrief`, from a fragment's metadata. */
export function isAgentBrief(metadata: Record<string, MetadataValue>): boolean {
  const v = metadata[AgentBrief.field];
  return v?.type === 'text' && v.value === AgentBrief.marker;
}
